export default __webpack_public_path__ + "static/media/afghanladynord.1cee11c7.png";